export default "__VITE_ASSET__DGt5nz$h__"